export default __webpack_public_path__ + "static/media/leaflet-marker-green-selected.d35902df.svg";